import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorScreen } from '@datapad/common-controls';
import { TreeReference } from '@datapad/data-model';
import { fail } from '@datapad/utilities';
import { Box } from '@mui/material';
import { MissingUser } from '../Constants.js';
import { PlayerView } from './PlayerView.js';
import { Toolbar } from './Toolbar.js';
export function PlayersView(props) {
    const { players, selection: selectedPlayer, changeSelection, addPlayer, deletePlayer } = props;
    let innerView;
    if (selectedPlayer === MissingUser) {
        innerView = _jsx(MissingPlayerErrorScreen, {});
    }
    else if (players.length === 0) {
        innerView = _jsx(NoPlayersErrorScreen, {});
    }
    else {
        const selectedPlayerOrDefault = selectedPlayer ?? players[0] ?? fail('Failed to get member of non-empty array.');
        innerView = (_jsx(PlayerView, { player: selectedPlayerOrDefault, deletePlayer: () => {
                deletePlayer(new TreeReference({ id: selectedPlayerOrDefault.id }));
                const firstRemainingPlayer = players.find((p) => p.id !== selectedPlayerOrDefault.id);
                changeSelection(firstRemainingPlayer);
            } }));
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
        }, children: [_jsx(Toolbar, { players: players, selection: selectedPlayer === MissingUser ? undefined : selectedPlayer, changeSelection: changeSelection, addPlayer: addPlayer }), _jsx(Box, { children: innerView })] }));
}
export function NoPlayersErrorScreen() {
    return (_jsx(ErrorScreen, { textLines: [
            'No players found.',
            'This is very unlikely and probably indicates an error.',
        ] }));
}
export function MissingPlayerErrorScreen() {
    return (_jsx(ErrorScreen, { textLines: [
            `The selected player does not exist.`,
            'This could indicate an error, or could indicate that the selected player has been deleted.',
        ] }));
}
//# sourceMappingURL=PlayersView.js.map